<template>
  <div class="heatmap_floating_menu"
    v-if="!isLoading"
    :class="{ active: isHeatmapOnHover, mobile: ['tap', 'zoom', 'swipe'].includes(eventType) }">
    <div class="heatmap_colorrange" v-if="['click', 'move', 'scroll'].includes(eventType)"
      :class="this.eventType === 'scroll' ? 'scroll' : 'regular'">
      <span class="hot">H</span>
      <span class="color-variation"></span>
      <span class="cold">C</span>
    </div>
    <div class="view_options">
      <div class="fitMode" :class="fitMode">
        <a href="#"
           :class="getFitModeClass('width')"
           @click.prevent="$emit('onFitModeChange', 'width')">
          <i class="icon icon--fit-horizontal"></i>
        </a>
        <a href="#"
           :class="getFitModeClass('height')"
           @click.prevent="$emit('onFitModeChange', 'height')">
          <i class="icon icon--fit-vertical"></i>
        </a>
      </div>
      <a href="#"
         class="download"
         :class="{hover: showDownloadButtonTooltip}"
         @mouseenter="onDownloadButtonMouseEnter"
         @mouseleave="onDownloadButtonMouseLeave"
         @click.prevent="onDownloadButtonClick">
        <i class="icon icon--download-heatmap"></i>
      </a>
      <ui-tooltip class="tooltip"
                  arrowBottom arrowRight
                  v-show="showDownloadButtonTooltip">
        <div v-html="$t('heatmap.downloadImage')"></div>
      </ui-tooltip>
    </div>
  </div>
</template>

<script>
import UiTooltip from '@/components/ui/UiTooltip'

export default {
  name: 'HeatmapFloatingMenu',
  components: {
    UiTooltip
  },
  props: [
    'fitMode',
    'eventType',
    'isHeatmapOnHover',
    'isLoading'
  ],
  data () {
    return {
      showDownloadButtonTooltip: false
    }
  },
  methods: {
    onDownloadButtonMouseEnter () {
      this.showDownloadButtonTooltip = true
    },
    onDownloadButtonMouseLeave () {
      this.showDownloadButtonTooltip = false
    },
    onDownloadButtonClick () {
      this.onDownloadButtonMouseLeave()
      this.$emit('onHeatmapDownload')
    },
    getFitModeClass (mode) {
      return {
        on: this.fitMode === mode,
        fit_to_width: mode === 'width',
        fit_to_height: mode === 'height'
      }
    }
  }
}
</script>

<style lang="scss">
.heatmap_floating_menu {
  height: 100%;

  &.mobile {
    top: 35px;
  }
}

.heatmap_colorrange {
  position: absolute;
  z-index: 1;
  top: 112px;
  right: 4px;
  width: 6px;
  border-radius: 2px;
  background: rgb(0, 0, 0);
  padding: 6px 3px;

  .hot,
  .cold {
    font-size: 10px;
    color: #fff;
    display: block;
    text-align: center;
    transform: translateX(-0.5px);
  }

  .color-variation {
    display: block;
    height: 120px;
    margin: 5px 0;
    border-radius: 5px;
  }

  &.regular .color-variation {
    background: linear-gradient(#fff, #ff0000, #fccb21, #00ff00, #1b85b9, #000);
  }

  &.scroll .color-variation {
    background: linear-gradient(#ff0000, #fccb21, #00ff00, #1b85b9, #000);
  }
}

.view_options {
  position: absolute;
  width: 20px;
  right: 0;
  z-index: 1;

  .fitMode {
    position: relative;
    background: rgba(0, 0, 0, 0.3);
    border-radius: 3px;
    border: 1px solid rgba(0, 0, 0, 0.3);

    &::before {
      z-index: 1;
      content: "";
      display: block;
      width: 20px;
      height: 20px;
      background: #ec0047;
      box-shadow: 0 2px 4px -11px rgba(0, 0, 0, 0.25);
      border-radius: 3px;
      position: absolute;
      top: -1px;
      left: -1px;
      transition: top 0.15s ease;
    }

    &.height::before {
      top: 19px;
    }

    a {
      position: relative;
      z-index: 2;
      display: block;
      width: 20px;
      height: 20px;

      &.fit_to_width {
        margin: -1px -1px 0 -1px;
      }

      &.fit_to_height {
        margin: 0 -1px -1px -1px;
      }
    }
  }

  .download {
    display: block;
    margin: 10px 0;
  }

  .tooltip {
    position: absolute;
    bottom: 42px;
    right: -19px;
    z-index: 10;
    text-align: right;
    font-size: 13px;
    line-height: 1.23;
    padding: 14px 13px 11px 13px;

    .arrow.bottom.right {
      right: 24px;
    }

    .text {
      color: #666666 !important;
      text-align: right;
    }
  }
}

.platform__window {
  .heatmap_floating_menu {
    right: 35px;
  }
}
</style>
